import styled from "styled-components";

export const Container = styled.div`
  margin: 36px auto 0;
  display: flex;
  flex-direction: column;

  @media (min-width: 980px) {
    flex-direction: row;
    margin: 40px auto 0;
    align-items: center;
  }

  @media (min-width: 1280px) {
    width: 1150px;
  }
`

export const Left = styled.div`
  margin-bottom: 40px;
  
  @media (min-width: 980px) {
    flex: 0 0 40%;
    margin-bottom: 0;
  }
`

export const Right = styled.div`
  @media (min-width: 980px) {
    margin-bottom: 0;
    flex: 0 0 60%;
  }
`

export const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 140%;
  color: #4E4963;
  margin-bottom: 24px;
  display: inline-block;
`

export const Text = styled.div`
  font-size: 14px;
  line-height: 170%;
  color: #2A2637;
  margin-bottom: 24px;

  @media (min-width: 980px) {
    font-size: 18px;
  }
`

export const Price = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 170%;
  color: #797199;
`

export const IconWrapp = styled.div`
  padding: 40px 72px 0 0;
  position: relative;

  @media (min-width: 980px) {
    padding: 81px 57px 0 0;
    position: relative;
    margin-right: 70px;
  }
`

export const IconBg = styled.div`
  background: #f7d5f0;
  border-radius: 36px;
  height: 116px;

  @media (min-width: 980px) {
    height: 265px;
    border-radius: 55px;
  }
`

export const IconPlace = styled.div`
  position: absolute;
  right: 0;
  left: 50px;
  bottom: 26px;
  background: #FFFFFF;
  border: 1px solid #C4BFD4;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 132px;

  img {
    width: 58px;
    height: auto;
  }

  @media (min-width: 980px) {
    border-radius: 10px;
    top: 0;
    bottom: 90px;
    height: inherit;
    left: 85px;

    img {
      width: inherit;
    }
  }
`